// @flow strict

import * as React from 'react';
import Header from '../../components/Header';
import FeaturedItem from '../../internal/FeaturedItem';
import Resources from './Internal/Resources';
import type { ResourceType } from './Internal/types';

type PropTypes = {|
  title: string,
  subtitle: string,
  intro: string,
  featuredResource?: ResourceType,
  guides: Array<ResourceType>,
  indicators: Array<ResourceType>,
  tools: Array<ResourceType>,
|};

export default (props: PropTypes) => {
  return (
    <>
      <Header title={props.title} subtitle={props.subtitle}>
        {props.intro}
      </Header>
      {props.featuredResource && (
        <FeaturedItem
          title={props.featuredResource.title}
          summary={props.featuredResource.description}
          image={props.featuredResource.image}
          alt={props.featuredResource.alt}
          ctaHref={props.featuredResource.href}
          ctaText="View details"
        />
      )}
      <Resources resources={props.guides} title="Guides" />
      <Resources resources={props.indicators} title="Indicators" />
      <Resources resources={props.tools} title="Tools" />
    </>
  );
};
